import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { FormFeedback, Input } from 'reactstrap';
import FabricOrderAction from 'store/fabric-order-resource/actions';
import ReadOnlyInput from './ReadOnlyInput';

function SelectBrand(props) {
  const dispatch = useDispatch()
  const store = useSelector(state => state)
  const { validation, edit, detail, detailIndex } = props
  const { setFieldValue, handleBlur, handleChange, values, errors, touched } = validation

  const onChange = e => {
    if (e) {
      dispatch(FabricOrderAction.getListBunch({ id: values.tradingCompanyId, brand: e.label }))
      setFieldValue(`details.${detailIndex}.brand`, e.label)
    } else {
      setFieldValue(`details.${detailIndex}.brand`, '')
      setFieldValue(`details.${detailIndex}.bunch`, '')
      setFieldValue(`details.${detailIndex}.fabricId`, '')

    }

  }

  if (edit || !detail.isIgarashi || detail.activeColumn == 1 || !detail.companyName) {
    return <ReadOnlyInput value={detail.brand} />
  }


  return (
    <>
      <Select
        isLoading={store.fabricOrder.brand.loading}
        isDisabled={edit}
        options={store.fabricOrder.brand.data.map(i => ({ value: i, label: i }))}
        defaultValue={{
          value: detail.brand,
          label: detail.brand
        }}
        value={{
          value: detail.brand,
          label: detail.brand
        }}
        onChange={onChange}
        isClearable
        menuPortalTarget={document.body}
        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
      />
    </>
  );
}

export default SelectBrand;